
import api from '../_api'
import {
    FETCH_DYNAMIC_SEARCH_REQUEST,
    FETCH_DYNAMIC_SEARCH_SUCCESS,
    FETCH_DYNAMIC_SEARCH_FAILED,
    FETCH_DYNAMIC_SEARCH_ITEM_DESCRIPTION_REQUEST,
    FETCH_DYNAMIC_SEARCH_ITEM_DESCRIPTION_SUCCESS,
    FETCH_DYNAMIC_SEARCH_ITEM_DESCRIPTION_FAILED,
    /** Tags */
    FETCH_TAGS_ALL_REQUEST,
    FETCH_TAGS_ALL_SUCCESS,
    FETCH_TAGS_ALL_FAILED
} from './mutation-type'

const fetchDynamicSearch = async ({ commit, state, getters, rootGetters }, { qtype, projectIdx, groupIdx, filter, indexes }) => {
    commit(FETCH_DYNAMIC_SEARCH_REQUEST)
    try {
        const { status, data } = await api.fetchDynamicSearch({ qtype, projectIdx, groupIdx, filter, indexes }, rootGetters.requiredService)
        commit(FETCH_DYNAMIC_SEARCH_SUCCESS, { status, data: data.data })
        return data
    } catch (error) {
        commit(FETCH_DYNAMIC_SEARCH_FAILED, error)
        throw error
    }
}

const fetchDynamicSearchItemDescription = async ({ commit, state, getters, rootGetters }, { qtype, projectIdx, groupIdx, filter }) => {
    commit(FETCH_DYNAMIC_SEARCH_ITEM_DESCRIPTION_REQUEST)
    try {
        const { status, data } = await api.fetchDynamicSearchItemDescription({ qtype, projectIdx, groupIdx, filter }, rootGetters.requiredService)
        commit(FETCH_DYNAMIC_SEARCH_ITEM_DESCRIPTION_SUCCESS, { status, data: data.data })
        return data
    } catch (error) {
        commit(FETCH_DYNAMIC_SEARCH_ITEM_DESCRIPTION_FAILED, error)
        throw error
    }
}
const getUserTag = async ({ commit, state, getters, rootGetters }) => {
    commit(FETCH_TAGS_ALL_REQUEST)
    try {
        const { status, data } = await api.fetchUserTag(rootGetters.requiredService)
        commit(FETCH_TAGS_ALL_SUCCESS, { status, data })
        return data
    } catch (error) {
        commit(FETCH_TAGS_ALL_FAILED, error)
        throw error
    }
}
export default {
    fetchDynamicSearch,
    fetchDynamicSearchItemDescription,
    /** Tags */
    getUserTag
}
